var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "d2-container",
    [
      _c(
        "el-menu",
        {
          staticClass: "el-menu-demo",
          attrs: { "default-active": _vm.activeIndex, mode: "horizontal" },
          on: {
            select: function($event) {
              return _vm.handover($event)
            }
          }
        },
        [
          _c("el-menu-item", { attrs: { index: "downAddress" } }, [
            _vm._v("下载地址")
          ]),
          _c("el-menu-item", { attrs: { index: "officePackage" } }, [
            _vm._v("官网包配置")
          ])
        ],
        1
      ),
      _c("downAddress", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.activeIndex == "downAddress",
            expression: "activeIndex == 'downAddress'"
          }
        ],
        ref: "downAddress"
      }),
      _c("officePackage", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.activeIndex == "officePackage",
            expression: "activeIndex == 'officePackage'"
          }
        ],
        ref: "officePackage"
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }